/*
 * Image preview script
 * powered by jQuery (http://www.jquery.com)
 *
 * written by Alen Grakalic (http://cssglobe.com)
 *
 * for more info visit http://cssglobe.com/post/1695/easiest-tooltip-and-image-preview-using-jquery
 *
 */
window.imagePreview = function() {
  /* CONFIG */

  let xOffset = 10;
  let yOffset = 30;

  // these 2 variable determine popup's distance from the cursor
  // you might want to adjust to get the right result

  /* END CONFIG */
  const previewElement = $('a.preview');

  previewElement.hover(function(e) {
        this.t = this.title;
        this.title = '';
        var c = (this.t !== '') ? '<br/>' + this.t : '';
        $('body').append('<p id=\'preview\'><img src=\'' + this.rel + '\' alt=\'Image preview\' />' + c + '</p>');
        $('#preview').css('top', (e.pageY - xOffset) + 'px').css('left', (e.pageX + yOffset) + 'px').fadeIn('fast');
      },
      function() {
        this.title = this.t;
        $('#preview').remove();
      });

  previewElement.mousemove(function(e) {
    $('#preview').css('top', (e.pageY - xOffset) + 'px').css('left', (e.pageX + yOffset) + 'px');
  });
};

// starting the script on page load
$(document).ready(function() {
  imagePreview();
});